<template>
  <el-dialog :close-on-click-modal="false" title="修改密码" :visible.sync="isShow" center @close="cancelDialog" width="30%">
    <div class="updatePassWord">
      <el-form :model="form" :rules="rules" ref="ruleForm" label-width="160px" label-position="right">
        <el-form-item label="请输入旧密码" prop="oldPassword">
          <el-input size="medium" v-model.trim="form.oldPassword" autocomplete="off" type="password" style="width: 80%"></el-input>
        </el-form-item>
        <el-form-item label="请输入新密码" prop="newPassword">
          <el-input size="medium" v-model.trim="form.newPassword" autocomplete="off" type="password" style="width: 80%"></el-input>
          <div class="tips">密码至少要包含8个字符，同时包含至少一个大写字母、一个小写字母、一个数字和一个特殊字符</div>
        </el-form-item>
        <el-form-item label="请确认新密码" prop="newPasswordOnce">
          <el-input size="medium" v-model.trim="form.newPasswordOnce" autocomplete="off" type="password" style="width: 80%"></el-input>
        </el-form-item>
      </el-form>
      <div class="submitBtn">
        <span>
          <el-button size="medium" class="cancelWireless" style="width: 120px" @click="cancelDialog">取 消</el-button>
        </span>
        <span>
          <el-button size="medium" type="primary" style="width: 120px" @click="confirmEvent">确 定</el-button>
        </span>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import md5 from 'js-md5';
import { updatePwd } from '../../http/api';
const passRex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^\da-zA-Z]).{8,}$/;
export default {
  props: ['isShow'],
  data() {
    const validatePassword = (rule, value, callback) => {
      if (passRex.test(value)) {
        callback();
      } else {
        callback(new Error('密码不符合格式要求'));
      }
    };
    const validatePasswordOnce = (rule, value, callback) => {
      if (value !== this.form.newPassword) {
        callback(new Error('两次密码输入不一致'));
      } else {
        callback();
      }
    };
    return {
      isShowDialog: false,
      form: {
        oldPassword: '',
        newPassword: '',
        newPasswordOnce: '',
      },
      rules: {
        oldPassword: [{ required: true, message: '旧密码不能为空', trigger: ['change'] }],
        newPassword: [{ required: true, validator: validatePassword, trigger: ['change'] }],
        newPasswordOnce: [{ required: true, validator: validatePasswordOnce, trigger: ['change'] }],
      },
    };
  },
  methods: {
    confirmEvent() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let userName = JSON.parse(localStorage.getItem('userInfo')).LoginName;
          updatePwd({
            oldPassword: md5(userName + this.form.oldPassword.trim()),
            newPassword: md5(userName + this.form.newPassword.trim()),
          }).then((res) => {
            this.$message({
              type: 'success',
              message: '修改成功，请重新登录',
            });
            this.$router.push('/login');
          });
        }
      });
    },
    cancelDialog() {
      this.$emit('cancel');
    },
  },
};
</script>
<style scoped lang="less">
.updatePassWord {
  margin: 0 16px;
  padding-top: 22px;
  padding-bottom: 32px;
}
.tips {
  // color: #ff4141;
  width: 80%;
  color: #ccc;
  line-height: 1;
}
.submitBtn {
  display: flex;
  justify-content: center;
  span:nth-of-type(2) {
    margin-left: 32px;
  }
}
</style>
